import React, { useEffect, useRef, useState } from "react";
import Swiper from "react-id-swiper";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/heroSlider.js";
import useSiteContent from "../hooks/useSiteContent";

function HeroSlider() {
  const { hero = {} } = useSiteContent("home");
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.preload = "auto";
    video.muted = true;
    video.playsInline = true;

    const handleCanPlay = () => {
      video.play().catch(() => {});
      setVideoPlaying(true);
    };
    video.addEventListener("canplaythrough", handleCanPlay);
    return () => video.removeEventListener("canplaythrough", handleCanPlay);
  }, []);

  return (
    <Styles>
      <section className="hero-slider-area">
        <Swiper>
          <div className="slider-item">
            <div className="video-container">
              {!videoPlaying && hero.backgroundImage && (
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/assets/images/${hero.backgroundImage}`
                  }
                  alt={hero.backgroundImage}
                  className="slider-image"
                />
              )}

              <video
                ref={videoRef}
                className="slider-video"
                src={
                  hero.video
                    ? `${process.env.PUBLIC_URL}/assets/images/${hero.video}`
                    : undefined
                }
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
              />
              <div className="video-overlay"></div>
            </div>

            <div className="slider-table">
              <div className="slider-tablecell">
                <Container>
                  <Row>
                    <Col md="12">
                      <div className="slider-box slider-box1">
                        <div className="slider-title">
                          <p>{hero.title}</p>
                        </div>
                        <div className="slider-desc">
                          <h1>{hero.desc}</h1>
                        </div>
                        <div className="slider-desc2">
                          <h1>{hero.desc2}</h1>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </Swiper>
      </section>
    </Styles>
  );
}

export default HeroSlider;
